var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutSize, useSlotVisibility } from "@/hooks/layout";
import { useLoadSystemConfigurationsQuery } from "@/store/api";
import { HeaderSmall } from "./headerSmall";
import { HeaderMedium } from "./headerMedium";
import { HeaderLarge } from "./headerLarge";
export default function Header() {
    var headerVisible = useSlotVisibility().headerVisible;
    var _a = useLayoutSize(), displayIsSmall = _a.displayIsSmall, displayIsMedium = _a.displayIsMedium, displayIsLarge = _a.displayIsLarge, displayIsXLarge = _a.displayIsXLarge, displayIs2XLarge = _a.displayIs2XLarge;
    var data = useLoadSystemConfigurationsQuery(null).data.data;
    // Invisible header
    if (!headerVisible) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("header", __assign({ className: "flex-row flex-none inline-block" }, { children: [displayIsSmall && _jsx(HeaderSmall, { data: data }), displayIsMedium && _jsx(HeaderMedium, { data: data }), (displayIsLarge || displayIsXLarge || displayIs2XLarge) && (_jsx(HeaderLarge, { data: data }))] })));
}
